module.exports = __webpack_public_path__ + "static/media/calendar.2bf06097.svg";